import React, { useState, useEffect, useMemo } from 'react';
import * as S from './styled';

interface SignupInputProps {
  placeholder: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  isValid: boolean;
  customStyles?: string;
}

export const SignupInput = ({
  placeholder,
  value,
  setValue,
  isValid,
  customStyles = '',
}: SignupInputProps) => {
  const [selected, setSelected] = useState<null | string>(null);
  const [error, setError] = useState(false);
  const DOMAINS = useMemo(() => ['gmail.com', 'yahoo.com', 'hotmail.com'], []);

  useEffect(() => {
    if (isValid) {
      const currentDomain = value.split('@')[1];
      setSelected(DOMAINS.indexOf(currentDomain) !== -1 ? currentDomain : null);
    }
  }, [value, DOMAINS, isValid]);

  const DomainsList = () => {
    const onAddDomainClick = (domain: string) => {
      if (!value) return;
      setValue((prevState) => (prevState.split('@')[0] += domain));
      setSelected(domain);
      setError(!!isValid);
    };

    const renderDomainItem = (d: string, index: number) => (
      <S.DomainBtn
        onClick={() => onAddDomainClick('@' + d)}
        id={'domain-button-' + (index + 1)}
        key={d}
      >
        @{d}
      </S.DomainBtn>
    );

    const list = DOMAINS.filter((d) => (value && selected ? d === selected : true));

    return <S.BtnContainer>{list.map(renderDomainItem)}</S.BtnContainer>;
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    setError(false);
  };

  const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    if (!event.relatedTarget?.id?.includes('domain')) {
      setError(!!value && !isValid);
    }
  };

  return (
    <>
      <S.Input
        autoFocus
        type="email"
        autoComplete="email"
        value={value}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        placeholder={placeholder}
        id={'sign-up-input'}
        $error={error}
        $customStyles={customStyles}
      />
      <DomainsList />
    </>
  );
};

export default SignupInput;
